<template>
<v-img src="" class="background-display">
  <v-container>
        <Navbar />
        <v-data-table :headers="headers" :items="todos" :search="search" :sort-by='fecha' disable-sort
        class="elevation-1" cols="12" xs="12" md="4" lg="4">
          <template v-slot:top>
            <v-toolbar dark color="#00b2bb">
              <v-row>
                <v-col>
                  <v-toolbar-title>
                    <h2 class="my-5 headline font-weight-thin">Mis Trámites</h2>
                  </v-toolbar-title>
                </v-col>
                <v-col>
                  <v-text-field
                      class="mt-5 ml-5"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                </v-col>
              </v-row>
            </v-toolbar>
            <v-alert v-model="alertAxios" class="mt-3" border="left" close-text="Close Alert" dismissible dense outlined type="error">
              Ha ocurrido un error!
            </v-alert>
          </template>
          <template v-slot:item.fecha="{ item }">
            <v-chip color="white">{{ displayValue(item.fecha)}}</v-chip>
          </template>
          <template v-slot:item.estadoTramite="{ item }">
            <v-chip v-if="item.estadoTramite === 'Esperando firmas'" :color="getColor(item.estadoTramite)" dark>{{ item.estadoTramite }}</v-chip>
            <v-chip v-else :color="getColor(item.estadoTramite)" dark>{{ item.estadoTramite }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
          <v-row>
            <v-col sm="4" class="hidden-xs-only">
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small color="#00b2bb" v-on="on" @click="goToEndTramite(item)">mdi-magnify</v-icon>
              </template>
              <span>Detalle Trámite</span>
            </v-tooltip>
            </v-col>
            <v-col sm="4" class="d-flex d-sm-none">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn dark small color="#00b2bb" v-on="on" @click="goToEndTramite(item)">Detalle Trámite</v-btn>
              </template>
              <span>Ver</span>
            </v-tooltip>
            </v-col>
            <v-col sm="4" style="display: none;">
            <v-tooltip right>
              <template v-slot:activator="{ on }" v-if="item.urlDocumento">
                <v-icon small color="#00b2bb" v-on="on" @click="downloadFile(item.urlDocumento)">mdi-download</v-icon>
              </template>
              <span>Descargar</span>
            </v-tooltip>
            </v-col>
            </v-row>
          </template>
        </v-data-table>
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
  </v-container>
  </v-img>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
.complete-text {
  word-break: break-all;
}
</style>

<script>
import api from '@/plugins/api'
import axios from 'axios'
import moment from '@/plugins/moment'
import Navbar from '@/components/Navbar'
import store from '@/store/index.js'

export default {
  components: { Navbar },
  data: () => ({
    overlay: false,
    alertAxios: false,
    url: '',
    search: '',
    fecha: '',
    headers: [
      { text: 'Tramite', align: 'center', value: 'nombreTramite' },
      { text: 'Estado', align: 'center', value: 'estadoTramite' },
      { text: 'Total', align: 'center', value: 'total' },
      { text: 'Fecha', align: 'center', value: 'fecha' },
      { text: '', value: 'actions' }
    ],
    todos: []
  }),
  /* watch: {
    overlay (val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3000)
    }
  }, */
  created () {
    this.initialize()
    this.getDate()
    this.$store.commit('setActualPage', store.state.actualPage)
    /* console.log(store.state.actualPage) */
    this.overlay = !this.overlay
  },
  methods: {
    async getTodos () {
      try {
        let tramites = []
        const response = await api.get('mis-tramites')
        tramites = response.data
        this.overlay = false
        /* console.log(response) */
        /* muestra fechas menores a 90 dias */
        this.todos = tramites.filter(lista =>
          moment(lista.fecha).format() >= moment().subtract(3, 'months').format())
        this.todos.sort(function compare (a, b) {
          var dateA = new Date(a.fecha)
          var dateB = new Date(b.fecha)
          return dateB - dateA
        })
        // oculta los tramites que no se han pagado y tienen mas de 3 dias
        this.todos = this.todos.filter(x => (x.estadoTramite !== 'Esperando pago' || moment(x.fecha).format() >= moment().subtract(3, 'days').format()))
        /* console.log(this.todos) */
      } catch (error) {
        this.alertAxios = true
        this.overlay = false
        console.log('Get error ' + error)
      }
    },
    goToEndTramite (item) {
      this.$router.push(`/StatusDocument/${item._id}`)
    },
    initialize () {
      this.getTodos()
    },
    // Es para la descarga del archivo pdf
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      /* console.log('aca ' + link.href) */
      link.setAttribute('download', 'Tramite.pdf') // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    // Es para la descarga del archivo pdf
    downloadFile (file) {
      axios({
        method: 'get',
        url: file,
        responseType: 'arraybuffer'
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('Error al descargar archivo'))
    },
    getDate () {
      const actualDAte = new Date()
      const day = actualDAte.getDate()
      const month = actualDAte.getMonth() + 1
      const year = actualDAte.getFullYear()
      this.fecha = day + '/' + month + '/' + year
    },
    displayValue (value) {
      return value ? moment(value).format('DD-MM-YYYY') : ''
    },
    // Genera el color del estado del tramite
    getColor (estadoTramite) {
      if (estadoTramite === 'Esperando pago') return 'red'
      else if (estadoTramite === 'Rechazado por Notario') return 'red accent-4'
      else if (estadoTramite === 'Esperando firmas') return 'yellow darken-3'
      else if (estadoTramite === 'Revisión') return 'orange darken-3'
      else if (estadoTramite === 'Finalizado') return 'primary'
      else return 'grey'
    }
  }
}
</script>
